import React from 'react'

const Loading = React.memo(() => {
    return <div className="loader"></div>
})

export default Loading